import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export interface Deferred {
  __deferred: {
    uri: string;
  };
}

@Pipe({
  name: 'deferred'
})
export class DeferredPipe implements PipeTransform {

  private _cached = new Map<string, Observable<any>>();

  constructor(
    private http: HttpClient,
  ) { }

  transform(value: Deferred): Observable<any> {
    const uri = value.__deferred.uri.replace('https://spteam.aa.com', '');
    const cache = this._cached.get(uri);
    if (!!cache) {
      return cache;
    } else {
      const request = this.http.get(uri).pipe(
        map((results: { d: any }) => (results || { d: {} }).d),
        shareReplay(1)
      );
      this._cached.set(uri, request);
      return request;
    }
  }

}

@NgModule({
  imports: [CommonModule],
  declarations: [DeferredPipe],
  exports: [DeferredPipe]
})
export class DeferredPipeModule { }
